let chartiqUiManagerGuardInstalled = false;

const ensureChartiqUiManagerRegistry = () => {
  const ciqRoot = globalThis as typeof globalThis & {
    CIQ?: {
      UI?: {
        _uiManagers?: WeakMap<object, unknown>;
      };
    };
  };

  if (!ciqRoot.CIQ?.UI) {
    return;
  }

  ciqRoot.CIQ.UI._uiManagers ||= new WeakMap<object, unknown>();
};

const installChartiqUiManagerGuard = () => {
  ensureChartiqUiManagerRegistry();
  if (chartiqUiManagerGuardInstalled) {
    return;
  }

  window.addEventListener('beforeunload', ensureChartiqUiManagerRegistry);
  chartiqUiManagerGuardInstalled = true;
};

export const getPreloadComplete = async () => new Promise<void>(resolve => {
  const script = document.createElement('script');
  script.onload = function () {
    globalThis.QEP.container.onReady(() => {
      installChartiqUiManagerGuard();
      resolve();
    });
  };

  script.src = '/preloads/qep-system.js';
  document.head.append(script);
});
